import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LicenseService} from 'app/core/services/license.service';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject, Subject, Subscription} from 'rxjs';
import {NotificationService} from 'app/core/services/notification.service';
import {SmartModalService} from 'app/core/services/smart-modal.service';
import {CardConfigurationService} from 'app/core/components/workflow-new/course/configurations/card-configuration.service';
import {CardConfiguration} from 'app/core/components/workflow-new/course/configurations/card-configuration';
import {ProfileService} from 'app/core/components/profile/profile.service';
import {CertificateService} from 'app/core/components/content/certificate/certificate.service';
import {RxComponent} from 'app/shared/components/common/rx.component';
import {DomainService} from 'app/core/services/domain.service';
import {StorageService} from 'app/core/services/storage.service';

@Component({
  selector: 'itpx-material-stack-presentation',
  templateUrl: './material-stack-presentation.component.html',
  styleUrls: ['./material-stack-presentation.component.css', '../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialStackPresentationComponent extends RxComponent implements OnInit {
  // @Output() private checkForUpdates$ = new EventEmitter<string>();
  private eLearningCertificates: any[];
  private backgroundUrl$: Observable<string>;
  private classConfig: CardConfiguration;
  private platformClass: any;
  private sub: Subscription;
  private deliverables$ = new ReplaySubject<Array<any>>(1);
  private learnerCertificates$ = new ReplaySubject<Array<any>>(1);
  private certificates: Array<any>;
  private errorMessage: String;
  private openModal = new Subject<any>();
  private updateContent = new Subject<any>();
  private tab: string;
  // private update = new Subject<any>();
  private classInfo = new Subject<any>();
  profile: any;
  lxpUser: boolean;
  completedAssignmentsCounter: number;
  courseId: string;
  courseEventId: string;

  @Input() materialDetails$: Observable<any>;
  @Input() state$: Observable<string>;

  constructor(private licenseService: LicenseService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private profileService: ProfileService,
    private certificateService: CertificateService,
    private modalService: SmartModalService,
    private cardConfiguration: CardConfigurationService,
    private domainService: DomainService,
    private storageService: StorageService
  ) {
    super();
  }

  ngOnInit() {
    this.tab = 'content';
    this.lxpUser = this.isLXPUser();
    this.backgroundUrl$ = this.domainService.getBanner();
    this.materialDetails$.bindToLifecycle(this).subscribe(details => {
      this.courseId = details.courseId;
      this.courseEventId = details.courseEventId;
      this.platformClass = details.material;
      this.eLearningCertificates = details.eLearningCertificates;
      this.classConfig = this.cardConfiguration.getConf(this.platformClass);
      this.classConfig.links = [
        // {
        //   disabled: false,
        //   tooltip: '',
        //   url: [],
        //   text: 'branded.portal.courses.assignment.update.check.button',
        //   type: LinkActions.ACTION,
        //   id: 'updateCheck'
        //   // type: LinkActions.REDIRECT
        // }
      ];
      this.classConfig.clickable = false;
      this.classConfig.imageHeight = '200';
      this.classConfig.imageWidth = '200';
      this.classConfig.cardHeight = '250';
      this.deliverables$.next(details.learnerDeliverables);

      // this.checkForUpdates$.emit(this.platformClass.id);
      this.learnerCertificates$.next(this.eLearningCertificates.map(cert => { cert.status = 'uptodate'; return cert; }));
      // this.ready();
    });
    // .map(res => res.data)

    // this.classConfig.cardWidth = '957';
    // this.ready();
    // this.state$.bindToLifecycle(this).subscribe(status => this.status = status)
  }

  // onClicked(event$: any) {
  //   if (event$.id === 'updateCheck')
  //     this.checkForUpdates$.emit(this.platformClass.id)
  // }

  // getType(course: any) {
  //   let c = this.cardConfiguration.getConf(course);
  //   c.cardWidth = '960';
  //   return c;
  // }

  // private checkContentUpdate(content: any, assignmentId: any) {
  //   if (content.data && content.data.length > 0) {
  //     this.openModal.next({ assignmentId: assignmentId, changedContents: content.data });
  //   }
  // }

  private onTabClicked(tab: string) {
    if (tab === 'achievements' && 0 === this.eLearningCertificates.length)
      return;
    this.tab = tab;
  }
  // private loadAssignments(deliverables: any, assignmentId: any) {
  //   if (deliverables['data'] && Array.isArray(deliverables.data) && deliverables.data.length > 0) {
  //     this.deliverables = deliverables['data'].map(d => {
  //       d.assignmentId = assignmentId;
  //       d.disabled = !d.enabled;
  //       return d;
  //     });
  //     this.certificateService.getElearningCertificates(assignmentId).subscribe(certificates => this.certificates = certificates.data);
  //     this.ready();
  //   } else {
  //     this.errorMessage = null;
  //     this.error();
  //   }
  // }

  // private checkContentUpdate(content: any, assignmentId: any) {
  //   if (content.data && content.data.length > 0) {
  //     this.openModal.next({ assignmentId: assignmentId, changedContents: content.data });
  //   }
  // }

  isLXPUser() {
    const lxpDomains = (this.storageService.get('lxp-domain-list') || '').split(', ');
    return lxpDomains.indexOf(this.domainService.parseDomain()) >= 0;
  }

  goBackToNewBP(route: string) {
    let url = `${window.location.origin}/hw/app/course/${this.courseId}`;
    if (route === 'course-event') {
      url += `/event/${this.courseEventId}`;
    }
    url += `?leapest-force-login=true`;
    if (route === 'course-event') {
      url += '$tab=materials';
    }

    window.location.href = url;
  }

  onParentTrigger(event: any) {
    this.completedAssignmentsCounter = event.completedDeliverableCount;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/material-stack-presentation/material-stack-presentation.component.ts